import { EAppSettings } from "library/types";
import { styledTheme } from "theme/mainTheme";
import { EThemeMode } from "theme/types";
import { useGetUserAppTargetSetting } from "./useGetUserAppTargetSetting";
import { useIsDarkMode } from "./useIsDarkMode";

export function useSelectedAppThemeFromSettings() {
  const darkMode = useIsDarkMode();

  const themeAppSetting = useGetUserAppTargetSetting({
    targetSettingName: EAppSettings.theme,
  });
  const selectedTheme = themeAppSetting?.userAppSettingValue
    ? JSON.parse(themeAppSetting?.userAppSettingValue)
    : null;

  const appTheme = selectedTheme
    ? selectedTheme[darkMode ? EThemeMode.dark : EThemeMode.light]
    : styledTheme;

  return appTheme;
}
